export default __webpack_public_path__ + "static/media/pvilla1-3.404ba34a.jpg";